const LabelText = ({ label, customLabelFontSize = "12px" }) => {
  const getChildType = (child) => {
    return typeof child;
  };
  return (
    <>
      {getChildType(label) === "string" && (
        <div
          className={`text-slate-500`}
          style={{
            lineHeight: "16px",
            fontSize: customLabelFontSize,
          }}
        >
          {label}
        </div>
      )}
    </>
  );
};
export default LabelText;
